// import { useEffect, useState } from "react";
// import { IAddCoupon, ICouponCategory } from "../AddCoupon/useAddCoupon";
// import ApiService from "../../../../service/ApiService";
// import { apiPaths } from "../../../../service/apiPaths";
// import toast from "react-hot-toast";

// const useEditCoupon = (id:string)=>{

//     const [loading, setLoading] = useState<boolean>(false);
//     const [couponCategories, setCouponCategories] = useState<ICouponCategory[]>([]);
//     const [formData, setFormData] = useState<IAddCoupon>({
//       type: "",
//       discountType: "PERCENTAGE",
//       discountValue: "0",
//       maxDiscountAmount: null,
//       isActive: true,
//       validFrom: new Date().toISOString().split("T")[0],
//       validUntil: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split("T")[0],
//       usageLimit: "-1",
//       usedCount: 0,
//     });

//     useEffect(() => {
//       // Fetch coupon categories
//       const fetchCouponCategories = async () => {
//         setLoading(true);
//         try {
//           const response = await ApiService({
//               method:"GET" ,
//               endpoint:`${apiPaths.coupons}/categories`
//           })

//           console.log(response)
//           // const mockCategories = [
//           //   { _id: "1", name: "Seasonal" },
//           //   { _id: "2", name: "Holiday" },
//           //   { _id: "3", name: "Special Event" },
//           //   { _id: "4", name: "New User" }
//           // ];
//           setCouponCategories(response.categories);
//         } catch (error) {
//           console.error("Error fetching coupon categories:", error);
//         } finally {
//           setLoading(false);
//         }
//       };

//       fetchCouponCategories();
//     }, []);

//     const handleChange = (
//       e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
//     ) => {
//       const { id, value, type } = e.target;

//       if (type === "checkbox") {
//         setFormData((prev) => ({
//           ...prev,
//           [id]: (e.target as HTMLInputElement).checked,
//         }));
//         return;
//       }

//       setFormData((prev) => ({
//         ...prev,
//         [id]: value,
//       }));
//     };

//     const handleSubmit = async (data: IAddCoupon) => {
//       setLoading(true);
//       try {

//           const response = await ApiService({
//               method:"POST" ,
//               endpoint:apiPaths.coupons ,
//               data:data
//           })

//           console.log(response)
//         toast.success("Coupon added successfully!");
//       } catch (error) {
//         toast.error("Error adding coupon:");
//         alert("Failed to add coupon.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     const handleCancel = () => {
//       // Implement navigation or reset logic
//       console.log("Cancelled");
//       setFormData({
//         type: "",
//         discountType: "PERCENTAGE",
//         discountValue: "1",
//         maxDiscountAmount: null,
//         isActive: true,
//         validFrom: new Date().toISOString().split("T")[0],
//         validUntil: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split("T")[0],
//         usageLimit: "-1",
//         usedCount: 0,
//       });
//     };

//     const fetchCouponDetails = async(couponId:string)=>{
//       try{
//         const couponDetails = await ApiService({
//           method:"GET" ,
//           endpoint:`${apiPaths.coupons}/${couponId}`
//         })

//         console.log(couponDetails)
//       }catch(err){
//         console.log(err)
//       }
//     }

//     return {formData , loading,couponCategories, handleChange , handleSubmit , handleCancel , fetchCouponDetails}

// }

// export default useEditCoupon

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { IAddCoupon, IStudent } from "../AddCoupon/useAddCoupon";
import { CouponCategory } from "../../interface";
import ApiService from "../../../../service/ApiService";
import { apiPaths } from "../../../../service/apiPaths";
import convertMongoDateToNormalDate from "../../dateSanitizer";
import toast from "react-hot-toast";

const useEditCoupon = (id: string | undefined) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [couponCategories, setCouponCategories] = useState<CouponCategory[]>([]);
  const [assignmentType, setAssignmentType] = useState<"everyone" | "specific">("everyone");
  const [selectedStudents, setSelectedStudents] = useState<IStudent[]>([]);
  const [formData, setFormData] = useState<IAddCoupon>({
    type: "",
    discountType: "PERCENTAGE",
    discountValue: "",
    maxDiscountAmount: null,
    isActive: true,
    validFrom: new Date().toISOString().split("T")[0],
    validUntil: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split("T")[0],
    usageLimit: "",
    usedCount: 0,
    isForNewUsersOnly: false,
  });

  const navigate = useNavigate();

  useEffect(() => {
    const fetchCouponData = async () => {
      if (!id) return;
      setLoading(true);
      try {
        // Fetch coupon data by ID (mock API call)
        const response = await ApiService({
          method: "GET",
          endpoint: `${apiPaths.coupons}/${id}`,
        });
        const data = {
          ...response.couponDetails,
          type: response.couponDetails.type.name,
          validFrom: convertMongoDateToNormalDate(response.couponDetails.validFrom),
          validUntil: convertMongoDateToNormalDate(response.couponDetails.validUntil),
        };

        if (data.assignmentType === "specific" && data.assignedUsers && data.assignedUsers.length > 0) {
          setAssignmentType("specific");
          setSelectedStudents(data.assignedUsers);
        } else {
          setAssignmentType("everyone");
        }

        console.log(data);

        setFormData(data);
      } catch (error) {
        console.error("Error fetching coupon data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCouponData();
  }, [id]);

  useEffect(() => {
    // Fetch coupon categories (same as in useAddCoupon)
    const fetchCouponCategories = async () => {
      setLoading(true);
      try {
        const response = await ApiService({
          method: "GET",
          endpoint: `${apiPaths.coupons}/categories`,
        });

        console.log(response);
        // const mockCategories = [
        //   { _id: "1", name: "Seasonal" },
        //   { _id: "2", name: "Holiday" },
        //   { _id: "3", name: "Special Event" },
        //   { _id: "4", name: "New User" }
        // ];
        setCouponCategories(response.categories);
      } catch (error) {
        console.error("Error fetching coupon categories:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCouponCategories();
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { id, value, type } = e.target;

    if (type === "checkbox") {
      const { checked } = e.target as HTMLInputElement;
      setFormData((prev: any) => ({
        ...prev,
        [id]: checked,
      }));
      return;
    }

    if (type === "number") {
      setFormData((prev: any) => ({
        ...prev,
        [id]: value === "" ? (id === "maxDiscountAmount" ? null : 0) : Number(value),
      }));
      return;
    }

    setFormData((prev: any) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleAssignmentTypeChange = (type: "everyone" | "specific") => {
    setAssignmentType(type);
    setFormData((prev) => ({
      ...prev,
      assignmentType: type,
    }));
  };

  const handleSubmit = async (data: IAddCoupon) => {
    const submissionData = {
      ...data,
      assignmentType,

      ...(assignmentType === "specific" && {
        assignedUsers: selectedStudents.map((student) => student._id),
      }),
    };

    // Validate student selection if specific assignment is chosen
    if (
      assignmentType === "specific" &&
      (!selectedStudents.length || !submissionData.assignedUsers?.length)
    ) {
      toast.error("Please select at least one student");
      setLoading(false);
      return;
    }

    if(new Date(data?.validFrom) > new Date(data?.validUntil)) {
        toast.error("Valid From date cannot be later than Valid Until date");
        setLoading(false);
        return;
      }

    console.log(submissionData);
    setLoading(true);
    try {
      const data = await ApiService({
        method: "PUT",
        endpoint: `${apiPaths.coupons}/${id}`,
        data: submissionData,
      });

      toast.success("Coupon updated successfully!");
      navigate("/coupon");
    } catch (error) {
      console.error("Error updating coupon:", error);
      toast.error("Failed to update coupon.");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/coupon"); // Redirect to the coupons list
  };

  const handleStudentSelect = (student: IStudent) => {
    // Check if student is already selected
    if (selectedStudents.some((s) => s._id === student._id)) {
      toast.error("Student already selected");
      return;
    }

    // Add student to selected list
    setSelectedStudents((prev) => [...prev, student]);

    setFormData((prev) => ({
      ...prev,
      assignedUsers: [...(prev.assignedUsers || []), student._id],
    }));

    toast.success(`${student.name || student.email} added to coupon recipients`);
  };

  const handleRemoveStudent = (id: string) => {
    console.log(id);
    // Remove student from selected list
    setSelectedStudents((prev) => prev.filter((student) => student._id !== id));

    // Update form data
    setFormData((prev) => ({
      ...prev,
      assignedUsers: prev.assignedUsers?.filter((studentId) => studentId !== id) || [],
    }));
  };

  const searchStudents = async (searchTerm: string) => {
    if (searchTerm.trim().length < 3) {
      toast.error("Please enter at least 3 characters to search");
      return [];
    }

    setLoading(true);
    try {
      const data = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.searchUsers}/${searchTerm}`,
      });

      if (!data || !data.students || data.students.length === 0) {
        toast.error("No students found matching the search term");
        return [];
      }

      return data.students;
    } catch (err) {
      console.error("Error searching students:", err);
      toast.error("Failed to search students");
      return [];
    } finally {
      setLoading(false);
    }
  };

  return {
    formData,
    loading,
    couponCategories,
    handleChange,
    handleSubmit,
    handleCancel,
    assignmentType,
    setAssignmentType,
    selectedStudents,
    setSelectedStudents,
    handleRemoveStudent,
    handleStudentSelect,
    searchStudents,
    handleAssignmentTypeChange,
  };
};

export default useEditCoupon;
